(function () {
  // Hide native 9.1 variant-selects when Variant Wizard app embed is active.
  // VW injects its own picker and doesn't know about the 9.1 custom element,
  // so we hide the native one to prevent duplicate pickers on the PDP.
  function hideNativeVariantSelects() {
    var style = document.createElement('style');
    style.textContent = 'variant-selects.product__selectors { display: none !important; }';
    document.head.appendChild(style);
  }

  // Only hide if VW's app embed script is present on the page
  if (document.querySelector('script[src*="variant-image-wizard"]')) {
    hideNativeVariantSelects();
  } else {
    // VW may load asynchronously — check once more after DOM is ready
    var checkVW = function () {
      if (document.querySelector('script[src*="variant-image-wizard"]')) {
        hideNativeVariantSelects();
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkVW, { once: true });
    } else {
      checkVW();
    }
  }

  function getPreviewThemeId() {
    return new URLSearchParams(window.location.search).get('preview_theme_id');
  }

  function buildSectionUrl(url, sectionId, variantId) {
    const requestUrl = new URL(url, window.location.origin);
    requestUrl.search = '';
    requestUrl.searchParams.set('section_id', sectionId);
    requestUrl.searchParams.set('variant', variantId);

    const previewThemeId = getPreviewThemeId();
    if (previewThemeId) {
      requestUrl.searchParams.set('preview_theme_id', previewThemeId);
    }

    return requestUrl.toString();
  }

  function buildVariantUrl(url, variantId) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.search = '';
    nextUrl.searchParams.set('variant', variantId);

    const previewThemeId = getPreviewThemeId();
    if (previewThemeId) {
      nextUrl.searchParams.set('preview_theme_id', previewThemeId);
    }

    return nextUrl.pathname + nextUrl.search;
  }

  function parseSelectedVariant(root) {
    const variantScript = root.querySelector('[data-selected-variant]');
    if (!variantScript) return null;

    try {
      return JSON.parse(variantScript.textContent);
    } catch (error) {
      console.error('APC variant sync could not parse selected variant JSON.', error);
      return null;
    }
  }

  function syncElementHtml(targetRoot, sourceRoot, id) {
    const target = targetRoot.querySelector('#' + CSS.escape(id));
    const source = sourceRoot.querySelector('#' + CSS.escape(id));

    if (!target || !source) return;

    target.className = source.className;
    target.innerHTML = source.innerHTML;
  }

  class APCVariantSync {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.sectionId = productInfo.dataset.section;
      this.unique = productInfo.dataset.sectionId;
      this.productUrl = productInfo.dataset.url;
      this.variantInput = productInfo.querySelector('input[name="id"][data-product-select]');

      if (!this.sectionId || !this.unique || !this.productUrl || !this.variantInput) {
        return;
      }

      this.lastVariantId = this.variantInput.value;
      this.isSyncing = false;

      this.handleVariantInputChange = this.handleVariantInputChange.bind(this);
      this.handleThemeVariantChange = this.handleThemeVariantChange.bind(this);

      this.connect();
    }

    connect() {
      this.productInfo.dataset.apcVariantSync = 'true';
      this.variantInput.addEventListener('change', this.handleVariantInputChange);

      this.variantObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.attributeName === 'value') {
            this.handleVariantInputChange();
            break;
          }
        }
      });

      this.variantObserver.observe(this.variantInput, {
        attributes: true,
        attributeFilter: ['value'],
      });

      this.pollInterval = window.setInterval(() => {
        if (this.variantInput.value !== this.lastVariantId) {
          this.handleVariantInputChange();
        }
      }, 500);

      this.disconnectInterval = window.setInterval(() => {
        if (!document.body.contains(this.productInfo)) {
          this.disconnect();
        }
      }, 2000);

      if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
        this.unsubscribe = window.subscribe(
          window.theme.PUB_SUB_EVENTS.variantChange,
          this.handleThemeVariantChange
        );
      }
    }

    disconnect() {
      if (this.isDisconnected) return;
      this.isDisconnected = true;

      this.variantInput.removeEventListener('change', this.handleVariantInputChange);
      this.variantObserver && this.variantObserver.disconnect();
      this.unsubscribe && this.unsubscribe();

      window.clearInterval(this.pollInterval);
      window.clearInterval(this.disconnectInterval);
    }

    handleThemeVariantChange(payload) {
      const data = payload && payload.data;
      if (!data || !data.variant || data.sectionId !== this.sectionId) return;

      this.lastVariantId = String(data.variant.id);
      this.dispatchLegacyVariantChange(data.variant);
    }

    handleVariantInputChange() {
      const variantId = this.variantInput.value;
      if (!variantId || variantId === this.lastVariantId || this.isSyncing) return;

      this.syncVariantState(variantId);
    }

    syncVariantState(variantId) {
      this.isSyncing = true;

      fetch(buildSectionUrl(this.productUrl, this.sectionId, variantId))
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sourceProductInfo = doc.getElementById('MainProduct--' + this.unique);

          if (!sourceProductInfo) return;

          const variant = parseSelectedVariant(sourceProductInfo);

          this.syncVariantBlocks(sourceProductInfo);
          this.syncFormState(sourceProductInfo, variant);
          this.syncQuantityState(sourceProductInfo);

          this.lastVariantId = String((variant && variant.id) || variantId);

          if (variant) {
            this.publishVariantChange(doc, variant);
            this.dispatchLegacyVariantChange(variant);
          }

          window.history.replaceState({}, '', buildVariantUrl(this.productUrl, this.lastVariantId));
        })
        .catch((error) => {
          console.error('APC variant sync failed to update the product form.', error);
        })
        .finally(() => {
          this.isSyncing = false;
        });
    }

    syncVariantBlocks(sourceProductInfo) {
      ['Price', 'Inventory', 'Badges', 'PreorderProperty'].forEach((prefix) => {
        syncElementHtml(this.productInfo, sourceProductInfo, prefix + '-' + this.unique);
      });

      const sourceAddToCartText = sourceProductInfo.querySelector(
        '#' + CSS.escape('AddToCartText-' + this.unique)
      );
      const targetAddToCartText = this.productInfo.querySelector(
        '#' + CSS.escape('AddToCartText-' + this.unique)
      );

      if (sourceAddToCartText && targetAddToCartText) {
        targetAddToCartText.innerHTML = sourceAddToCartText.innerHTML;
      }
    }

    syncFormState(sourceProductInfo, variant) {
      const sourceFormWrapper = sourceProductInfo.querySelector('[data-form-wrapper]');
      const targetFormWrapper = this.productInfo.querySelector('[data-form-wrapper]');

      if (sourceFormWrapper && targetFormWrapper) {
        targetFormWrapper.dataset.variantPrice = sourceFormWrapper.dataset.variantPrice || '';

        if (sourceFormWrapper.dataset.variantComparePrice) {
          targetFormWrapper.dataset.variantComparePrice = sourceFormWrapper.dataset.variantComparePrice;
        } else {
          delete targetFormWrapper.dataset.variantComparePrice;
        }

        ['variant--soldout', 'variant--unavailable'].forEach((className) => {
          targetFormWrapper.classList.toggle(className, sourceFormWrapper.classList.contains(className));
        });
      }

      const sourceSubmitButton = sourceProductInfo.querySelector('[data-add-to-cart]');
      const targetSubmitButton = this.productInfo.querySelector('[data-add-to-cart]');

      if (sourceSubmitButton && targetSubmitButton) {
        targetSubmitButton.disabled = sourceSubmitButton.disabled;

        if (sourceSubmitButton.hasAttribute('disabled')) {
          targetSubmitButton.setAttribute('disabled', 'disabled');
        } else {
          targetSubmitButton.removeAttribute('disabled');
        }
      }

      const sourceBuyNow = sourceProductInfo.querySelector('[data-buy-it-now]');
      const targetBuyNow = this.productInfo.querySelector('[data-buy-it-now]');

      if (sourceBuyNow && targetBuyNow) {
        targetBuyNow.classList.toggle('hidden', sourceBuyNow.classList.contains('hidden'));
      }

      if (variant) {
        this.variantInput.value = String(variant.id);
        this.variantInput.setAttribute('value', String(variant.id));
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    syncQuantityState(sourceProductInfo) {
      const sourceQuantityWrapper = sourceProductInfo.querySelector(
        '#' + CSS.escape('Quantity-Form-' + this.unique)
      );
      const targetQuantityWrapper = this.productInfo.querySelector(
        '#' + CSS.escape('Quantity-Form-' + this.unique)
      );

      if (!sourceQuantityWrapper || !targetQuantityWrapper) return;

      const sourceField = sourceQuantityWrapper.querySelector('[data-quantity-field]');
      const targetField = targetQuantityWrapper.querySelector('[data-quantity-field]');

      if (sourceField && targetField) {
        ['data-cart-quantity', 'data-min', 'data-max', 'step', 'min', 'max'].forEach((attr) => {
          const value = sourceField.getAttribute(attr);
          if (value === null) {
            targetField.removeAttribute(attr);
          } else {
            targetField.setAttribute(attr, value);
          }
        });

        const nextValue =
          sourceField.getAttribute('min') ||
          sourceField.getAttribute('data-min') ||
          sourceField.value ||
          '1';

        targetField.value = nextValue;

        const quantitySelect = this.productInfo.querySelector('[data-quantity-select]');
        if (quantitySelect) {
          quantitySelect.textContent = nextValue;
        }

        targetField.dispatchEvent(new Event('input', { bubbles: true }));
        targetField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const sourceRules = sourceQuantityWrapper.querySelector('[data-quantity-rules]');
      const targetRules = targetQuantityWrapper.querySelector('[data-quantity-rules]');

      if (sourceRules && targetRules) {
        targetRules.innerHTML = sourceRules.innerHTML;
        targetRules.className = sourceRules.className;
      }
    }

    publishVariantChange(doc, variant) {
      if (window.publish && window.theme && window.theme.PUB_SUB_EVENTS) {
        window.publish(window.theme.PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html: doc,
            variant: variant,
          },
        });
      }
    }

    dispatchLegacyVariantChange(variant) {
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: { variant: variant },
        })
      );
    }
  }

  function bootVariantSync(root) {
    root
      .querySelectorAll('product-info:not([data-apc-variant-sync])')
      .forEach((productInfo) => new APCVariantSync(productInfo));
  }

  function start() {
    bootVariantSync(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches && node.matches('product-info:not([data-apc-variant-sync])')) {
            new APCVariantSync(node);
          } else if (node.querySelectorAll) {
            bootVariantSync(node);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
